import PropTypes from 'prop-types';
import DashboardNoRecord from '../DashboardNoRecord/DashboardNoRecord';
import DashboardTransactionsTableRow from './DashboardTransactionsTableRow';

function DashboardTransactionsTable({ transactions }) {
  return (
    <div className="mt-4 rounded-lg border border-rcgray-200 bg-rcgray-50/50 p-4 shadow-md">
      <table className="min-w-full divide-y divide-gray-300">
        <thead>
          <tr>
            <th
              scope="col"
              className="py-3.5 pr-3 pl-4 text-left font-semibold text-gray-900 text-sm sm:pl-0"
            >
              Details
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left font-semibold text-gray-900 text-sm sm:table-cell"
            >
              Amount
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left font-semibold text-gray-900 text-sm sm:table-cell"
            >
              Purchase
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left font-semibold text-gray-900 text-sm sm:table-cell"
            >
              Date
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {transactions.length > 0 ? (
            transactions.map((transaction) => (
              <DashboardTransactionsTableRow
                key={transaction.id}
                transaction={transaction}
              />
            ))
          ) : (
            <tr>
              <td colSpan={4} className="py-4">
                <DashboardNoRecord text="Sorry, you don't have any recent transactions." />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

DashboardTransactionsTable.propTypes = {
  transactions: PropTypes.array.isRequired,
};

export default DashboardTransactionsTable;
